export default __webpack_public_path__ + "static/media/provider.8a69e340.png";